/**
 * Formats GeoJSON coordinates as a lat-lng collection string
 * @param {*} coordinates
 * @returns {string}
 */
export function latLngCollection(coordinates) {
  if (coordinates?.coordinates) {
    ({ coordinates } = coordinates);
  }
  if (!coordinates?.length) {
    return '';
  }
  if (Array.isArray(coordinates[0])) {
    const value = coordinates.map(latLngCollection).join(', ');
    return Array.isArray(coordinates[0][0]) ? value : `[ ${value} ]`;
  }
  return '(' + coordinates.slice().reverse().join(', ') + ')';
}
